import { CustomerDetailSection } from '@ca/common'
import useSession from 'hooks/useSession'

export const markDetailSectionSaved = (section: CustomerDetailSection) => {
  const { info } = useSession.getState()
  const saved = info.savedDetailSections ?? []
  const savedDetailSections = saved.includes(section)
    ? saved
    : [...saved, section]

  useSession.getState().setInfo({
    isCustomerDetailsConfirmed: false,
    savedDetailSections,
  })
}
